import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import CarrierRow from './CarrierRow';

import { useTranslation } from 'services/localization/useTranslation';
import { Carrier } from 'common/types';

interface Props {
	carriers: Carrier[];
}

const CarriersTable = ({ carriers }: Props) => {
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<TableContainer>
			<Table>
				<TableHead className={classes.tableHead}>
					<TableRow className={classes.tableRow}>
						<TableCell>{t('delivery.name', 'Name')}</TableCell>
						{/*
						*
						Hidden at the moment since we don't give the user the option to change the location for a carrier.
						- Axel 24th of June 2021
						*
							<TableCell>{t('common:shopLocation.store', 'Store')}</TableCell>
						 */}
						<TableCell />
					</TableRow>
				</TableHead>
				<TableBody>
					{carriers.map((row) => (
						<CarrierRow key={row.id} row={row} />
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		tableHead: {
			backgroundColor: theme.palette.background.secondary,
		},
		tableRow: {
			verticalAlign: 'baseline',
			'& > *': {
				borderBottom: `1px solid ${theme.palette.border.table}`,
				whiteSpace: 'nowrap',
				'&:first-child': {
					paddingLeft: theme.spacing(4),
				},
			},
		},
	}),
);

export default CarriersTable;
